// extracted by mini-css-extract-plugin
module.exports = {"threePoints":"BonusActions_threePoints__1XG_O","trigger":"BonusActions_trigger__2GkP4"};